module.exports = window["wp"]["a11y"];